import * as React from 'react';

export const Icon3d = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 25">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.39 5.818L10.5 0 .61 5.818l9.89 5.818 9.89-5.818zM21 6.893l-9.882 5.813v11.637L21 18.529V6.893zM9.882 24.343V12.706L0 6.893v11.636l9.882 5.814z"
      fill="#fff"
    />
  </svg>
);

Icon3d.displayName = 'Icon3d';
